<div class="flex flex-col -m-6">

  <!-- Header -->
  <div
    class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
    <div class="text-lg font-medium">{{ 'requestDTypeToGoLiveDialog.title' | transloco }}</div>
    <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
      <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
    </button>
  </div>

  <!-- Content -->
  <ng-container>
    <div class="flex flex-col p-6">
      @if (readOnly) {
        <mat-form-field class="w-full" disabled>
          <mat-label>{{ 'requestDTypeToGoLiveDialog.user' | transloco }}</mat-label>
          <input matInput [readonly]="readOnly" [formControl]="requestUser">
        </mat-form-field>
      }
      @if (readOnly) {
        <mat-form-field class="flex flex-col w-full items-center cursor-pointer" disabled="readOnly">
          <mat-label>{{ 'requestDTypeToGoLiveDialog.dateRequest' | transloco }}</mat-label>
          <input readonly matInput [formControl]="requestDate"
            [matDatepicker]="datepicker2"
            (click)="openDatepickerOnClick(datepicker)">
            <mat-datepicker-toggle [disabled]="readOnly" matSuffix [for]="datepicker2"></mat-datepicker-toggle>
            <mat-datepicker #datepicker2 [startView]="'month'"></mat-datepicker>
          </mat-form-field>
        }
        <mat-form-field class="flex flex-col w-full items-center cursor-pointer" disabled="readOnly">
          <mat-label>{{ 'requestDTypeToGoLiveDialog.date' | transloco }}</mat-label>
          <input readonly matInput [formControl]="date"
            [min]="datemin"
            [matDatepicker]="datepicker"
            (click)="openDatepickerOnClick(datepicker)">
            <mat-datepicker-toggle [disabled]="readOnly" matSuffix [for]="datepicker"></mat-datepicker-toggle>
            <mat-datepicker #datepicker [startView]="'month'"></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="w-full" disabled="readOnly">
            <mat-label>{{ 'requestDTypeToGoLiveDialog.observations' | transloco }}</mat-label>
            <textarea matInput [readonly]="readOnly" [disabled]="readOnly" [formControl]="observations"
            [rows]="3" [cols]="1"></textarea>
          </mat-form-field>
          @if (!readOnly) {
            <div class="w-full"> {{ 'requestDTypeToGoLiveDialog.endText' | transloco }} </div>
          }
        </div>
      </ng-container>

      <!-- Actions -->
      <div class="flex flex-col sm:flex-row justify-end gap-2 px-4 pb-2 sm:px-8 sm:pb-8 w-full">
        @if (!readOnly) {
          <button (click)="closeDialog()" mat-stroked-button>
            {{ 'cancel' | transloco }}
          </button>
        }
        @if (!readOnly) {
          <button (click)="save()" mat-flat-button color="primary">
            {{ 'accept' | transloco }}
          </button>
        }
        @if (readOnly) {
          <button (click)="closeDialog()" mat-flat-button color="primary">
            {{ 'accept' | transloco }}
          </button>
        }
      </div>
    </div>